import React from 'react';
import styles from './PieChartTooltip.module.css';

interface PieChartTooltipProps {
	active?: boolean;
	payload?: any[];
}

export const PieChartTooltip: React.FC<PieChartTooltipProps> = ({ active, payload }) => {
	if (!active || !payload || payload.length === 0) {
		return null;
	}

	const data = payload[0];
	const percentage = data.payload?.percentage || 0;
	const color = data.payload?.color || data.fill || '#689ee6';

	return (
		<div className={styles.tooltip}>
			<div className={styles.item}>
				<div className={styles.labelWrapper}>
					<div className={styles.dot} style={{ backgroundColor: color }} />
					<span className={styles.label}>{data.name}</span>
				</div>
				<span className={styles.value}>
					{data.value} usuários ({percentage}%)
				</span>
			</div>
		</div>
	);
};
